<div class="common-style position-relative">
  <div class="panel-header d-flex align-items-center justify-content-between">
    <div class="panel-header-spacer"></div>
    <h6 class="panel-title mb-0 flex-grow-1 text-center">
      {{
        mode === 'create'
          ? 'Create New Template'
          : mode === 'edit'
            ? ('Edit Template: ' + (form?.get('name')?.value || ''))
            : ('View Template: ' + (form?.get('name')?.value || ''))
      }}
    </h6>
    <div class="panel-actions d-flex align-items-center">
      <button type="button" mat-icon-button class="panel-close-btn" (click)="cancel()" [disabled]="isSubmitting" matTooltip="Cancel">
        <mat-icon class="material-symbols-outlined">close</mat-icon>
      </button>
    </div>
  </div>

  @if (viewLoading) {
    <div class="dialog-body mt-2 mb-2 common-style">
      <div class="drawer-skeleton">
        <div class="skeleton-line w-35"></div>
        <div class="skeleton-box"></div>
        <div class="skeleton-line w-30"></div>
        <div class="skeleton-box"></div>
        <div class="skeleton-line w-30"></div>
        <div class="skeleton-box"></div>
        <div class="skeleton-line w-30"></div>
        <div class="skeleton-box tall"></div>
      </div>
    </div>
  } @else {
    <form id="templateDialogForm" class="dialog-body mt-2 mb-2 form common-style" [formGroup]="form" (ngSubmit)="save()">
      <div class="row">
        @if (mode !== 'edit') {
          <!-- Template Type -->
          <div class="col-sm-12 mb-3">
            <span class="title-name">Template Type <span class="mandatory-star">*</span></span>
            <div class="error-input-wrapper">
              <app-custom-select label="Template Type" [items]="templateTypes" formControlName="templateType"
                bindLabel="label" bindValue="value" optionIconKey="icon" placeholder="Select a template type">
              </app-custom-select>
              @if (form.get('templateType')?.touched && form.get('templateType')?.invalid) {
                <mat-error>Template Type is required</mat-error>
              }
            </div>
          </div>
        }

        <!-- Template Name -->
        <div class="col-sm-12 mb-3">
          <span class="title-name">Template Name <span class="mandatory-star">*</span></span>
          <div class="error-input-wrapper">
            <input id="template_name_input" type="text" class="form-control"
              placeholder="e.g., System Outage Notice" formControlName="name">
            @if (form.get('name')?.touched && form.get('name')?.hasError('required')) {
              <mat-error>Template Name is required</mat-error>
            }
            @if (form.get('name')?.touched && (form.get('name')?.hasError('pattern') || form.get('name')?.hasError('invalidName'))) {
              <mat-error>Template Name is invalid</mat-error>
            }
          </div>
        </div>

        <!-- Subject Line -->
        <div class="col-sm-12 mb-3">
          <span class="title-name">Subject Line <span class="mandatory-star">*</span></span>
          <div class="error-input-wrapper">
            <input id="template_subject_input" type="text" class="form-control"
              placeholder="e.g., Service Interruption: {{'{{service_name}}'}}" formControlName="subject">
            @if (form.get('subject')?.touched && form.get('subject')?.hasError('required')) {
              <mat-error>Subject Line is required</mat-error>
            }
            @if (form.get('subject')?.touched && (form.get('subject')?.hasError('pattern') || form.get('subject')?.hasError('invalidName'))) {
              <mat-error>Subject Line is invalid</mat-error>
            }
          </div>
        </div>

        <!-- Message Body (Quill Editor) -->
        <div class="col-sm-12 mb-3">
          <span class="title-name">Message Body <span class="mandatory-star">*</span>
            @if (bodyLength !== null) {
              <span class="ms-3">({{bodyLength}} Char)</span>
            }
          </span>
          <quill-editor id="template_body_editor" class="d-flex flex-column messagefield" appStatusDrawerQuillKeyboard [placeholder]="' '"
            [modules]="messageEditorModules"
            formControlName="body" theme="snow" [readOnly]="isReadOnly">
          </quill-editor>
          @if (form.get('body')?.hasError('required') && form.get('body')?.touched) {
            <mat-error class="mt-2 des-error">Message Body is required</mat-error>
          }
          @if (form.get('body')?.touched && (form.get('body')?.hasError('pattern') || form.get('body')?.hasError('invalidDescription'))) {
            <mat-error class="mt-2 des-error">Message Body is invalid</mat-error>
          }
          @if (form.get('body')?.hasError('maxTextLength') && form.get('body')?.touched) {
            <mat-error class="mt-2 des-error">Message Body must be 5000 characters or fewer</mat-error>
          }
        </div>
      </div>
    </form>
  }

  <div class="modal-action mt-auto p-4">
    @if (isReadOnly) {
      <button id="template_dialog_close" type="button" class="bt-border" mat-raised-button
        (click)="cancel()">Close</button>
    } @else {
      <button id="template_dialog_cancel" type="button" class="bt-border" mat-raised-button
        (click)="cancel()">Cancel</button>
      <button id="template_dialog_save" type="submit" class="bt-background ms-5" [disabled]="isSaveDisabled"
        mat-raised-button form="templateDialogForm">
        {{ mode === 'create' ? 'Create' : 'Save Changes' }}
      </button>
    }
  </div>

    <!-- Spinner Overlay -->
    @if (isSubmitting) {
        <div class="drawer-spinner-overlay">
            <mat-spinner diameter="30"></mat-spinner>
        </div>
    }
</div>
